
import moment from "moment";
export default {
  namespaced: true,

  state: {
  
    shifts: [],
    hospitalStay: {
      max: null,
      hospital_stay: 0,
      hospital_stays_enhanced_flow: 0,
      still_in_hospital: 0,
      from_date: null,
      to_date: null,
    }
  },

  getters: {
    stayIsValid: (state,getters) => {
       return (getters.fromIsValid && getters.toIsValid) ? true : false;
    },
    fromIsValid: (state,getters) => {
      	//The Hospital Stay From Date cannot be after the shift check out date 
       //The Hospital Stay From Date cannot be after the Hospital Stay End Date

      return (getters.fromConditionOne && getters.fromConditionTwo) ? true : false;
    },
    toIsValid: (state,getters) => {
      /* The Hospital Stay End Date cannot be after the shift check out date 
       The Hospital Stay End Date cannot be before the Hospital Stay From Date */
       if(state.hospitalStay.still_in_hospital === true || state.hospitalStay.still_in_hospital == 1 )
        {
          return true;
        }
     
       return (getters.toConditionOne && getters.toConditionTwo) ? true : false;
     },
    fromConditionOne  : (state) => {
      //The Hospital Stay From Date cannot be after the shift check out date 
      let from = moment(state.hospitalStay.from_date);
      let max = moment(state.hospitalStay.max);
      return (from <= max) ?  true :  false;
    },
    fromConditionTwo  : (state) => {
     //The Hospital Stay From Date cannot be after the Hospital Stay End Date
      if (state.hospitalStay.still_in_hospital == 1 || state.hospitalStay.hospital_stay == "1") {
        return true;
      }
      let from = moment(state.hospitalStay.from_date);
      let to = moment(state.hospitalStay.to_date);
      return (from <= to) ?  true :  false;
      
    },
    toConditionOne  : (state) => {
      //The Hospital Stay End Date cannot be after the shift check out date 
      let to = moment(state.hospitalStay.to_date);
      let max = moment(state.hospitalStay.max);
         
        return (to <= max) ?  true :  false;

    },
    toConditionTwo  : (state) => {
     // The Hospital Stay End Date cannot be before the Hospital Stay From Date
      let from = moment(state.hospitalStay.from_date);
      let to = moment(state.hospitalStay.to_date);
        return (from <= to) ?  true :  false;
    },
  
  },
  mutations: {
    setShifts(state, payload) {
      state.shifts = payload;
    },
    setHospitalStay(state, payload) {
      state.hospitalStay.hospital_stay = (payload.hospital_stay == true) ? 1 : 0;
      state.hospitalStay.max = moment(payload.checked_out_time).format('MM/DD/YYYY') ?? null;
      state.hospitalStay.hospital_stays_enhanced_flow = (payload.client.carrier.hospital_stays_enhanced_flow == true) ? 1 : 0;
      state.hospitalStay.still_in_hospital = payload.still_in_hospital ? 1 : 0;
      state.hospitalStay.from_date = (payload.hospital_stay_from_date) ? moment(payload.hospital_stay_from_date).format('MM/DD/YYYY') : null;
      state.hospitalStay.to_date = (payload.hospital_stay_to_date) ? moment(payload.hospital_stay_to_date).format('MM/DD/YYYY') : null;
    },
    resetHospitalStay(state) { 
      state.hospitalStay = {
        max: null,
        hospital_stay: null,
        hospital_stays_enhanced_flow: 0,
        still_in_hospital: 0,
        from_date: null,
        to_date: null,
      };
    },
    setHospitalStayMax(state, payload) {
      state.hospitalStay.max = payload;
    },
    setHospitalStayFrom(state, payload) {
      state.hospitalStay.from_date = payload;
    },
    setHospitalStayTo(state, payload) {
      state.hospitalStay.to_date = payload;
    },
    setHospitalStayEnhancedFlow(state, payload) {
      state.hospitalStay.hospital_stays_enhanced_flow = payload;
    },
    setHospitalStayStillInHospital(state, payload) {
      state.hospitalStay.still_in_hospital = payload;
    },
    setHospitalStayHospitalStay(state, payload) {
      state.hospitalStay.hospital_stay = payload;
    },
    setHospitalStayStayValid(state, payload) {
      state.hospitalStay.stayValid = payload;
    },
    setHospitalStayToValid(state, payload) {
      state.hospitalStay.toValid = payload;
    },
  },

  actions: {

    getShifts({ commit }, payload) {
    
      var route =null;

      switch (payload.role) {

        case 'client':
          route =   '/client/shifts/' + payload.id + '&json=1'
          break;
        case 'caregiver': 
          route =   '/caregiver/shifts/edit/' + payload.id + '&json=1'
          break;
        default:
          route =   '/business/shifts/' + payload.id + '&json=1'
          break;
      }

      axios.get(route)
        .then(response => {

          commit('setShifts', response.data);
          let data = response.data;
          commit('setHospitalStay', data);

        }).catch(error => {
         

        });
    },
    setHospitalStayVariable({ commit,getters }, [payload, name]) {
     
      switch (name) {
        case 'max':
          commit('setHospitalStayMax', payload);
          break;
        case 'hospital_stay':
          commit('setHospitalStayHospitalStay', payload);
          break;
        case 'hospital_stays_enhanced_flow':
          commit('setHospitalStayEnhancedFlow', payload);
          break;
        case 'from_date':
          commit('setHospitalStayFrom', payload);
          break;
        case 'to_date':
          commit('setHospitalStayTo', payload);
          break;
        case 'still_in_hospital':
          commit('setHospitalStayStillInHospital', payload);
          break;
        case 'fromValid':
          commit('setHospitalStayFromValid', payload);
          break;
        case 'toValid':
          commit('setHospitalStayToValid', payload);
          break;
        case 'stayValid':
          let valid =  getters.getValid
          commit('setHospitalStayStayValid', valid);
          break;
        default:
          break;
      }


    },
    setupComponent({ state, commit, dispatch }, data) {
  
      dispatch('setHospitalStayVariable', [data.checked_out_time, 'max']);
      dispatch('setHospitalStayVariable', [data.hospital_stay, 'hospital_stay']);
      dispatch('setHospitalStayVariable', [data.client.carrier.hospital_stays_enhanced_flow, 'hospital_stays_enhanced_flow']);
      dispatch('setHospitalStayVariable', [data.hospital_stay_from_date, 'from_date']);
      dispatch('setHospitalStayVariable', [data.hospital_stay_to_date, 'to_date']);
      dispatch('setHospitalStayVariable', [data.still_in_hospital, 'still_in_hospital']);
    },
    updateMax({ commit }, payload) {
      commit('setHospitalStayMax', payload);
    },
    resetHospitalStay({ commit }) {
      commit('resetHospitalStay');
    }
  }

}